module.exports = __webpack_public_path__ + "static/media/change1.65af35fe.svg";